import React from "react";
import { Layout, TripleLights, Ads } from "~/src/components";
import { Header, CardsBlock } from "planetyze-ui";
import { Guidebook } from "./components";
import { graphql } from "react-apollo";
import query from "./Blog.gql";
import getContext from "context";

const Blog = props => {
  const { t } = getContext();

  return (
    <Layout.Loader {...props.data}>
      {({ blog, blogs, location }) => {
        const path = [
          { label: t("japan"), url: "/" },
          { label: blog.location.name, url: blog.location.url },
          { label: t("common.blogs"), url: blog.location.url + "/blogs" }
        ];

        const params = {
          blog: blog.title,
          locaiton: blog.location.name,
          description: blog.content
            .replace(/(<([^>]+)>)/gi, "")
            .substring(0, 150)
        };

        return (
          <Layout
            title={t("seo.blog.title", params)}
            description={t("seo.blog.description", params)}
            pageType="blog"
            url={props.uri}
            location={blog.location.slug}
          >
            <div className="container mx-auto max-w-xl">
              <Header
                title={blog.title}
                className="mb-8 max-w-lg"
                titleClass="text-5xl lg:text-6xl"
                path={path}
              />

              <div
                id="root"
                className="blog-content blog-content-format"
                dangerouslySetInnerHTML={{
                  __html: blog.content.replace("<p>&nbsp;</p>", "")
                }}
              />

              {blog.guidebook.length > 0 &&
                blog.guidebook.map(item => (
                  <Guidebook key={`guidebook-${item.id}`} {...item} />
                ))}

              <Ads className="mb-10" />

              <TripleLights
                location={blog.location.slug}
                medium="blog"
                campaign={blog.url}
              />
            </div>
            <div className="container mt-4">
              <CardsBlock
                key={`blogs`}
                title={`Related Blogs & Articles`}
                url={`${blog.location.url}/blogs`}
                items={blogs.nodes}
                pageInfo={blogs.pageInfo}
                theme="lg"
                slider
              />
            </div>
          </Layout>
        );
      }}
    </Layout.Loader>
  );
};

export default graphql(query, {
  options: props => {
    return {
      variables: {
        blog: props.blog,
        location: props.slug || "japan"
      }
    };
  }
})(Blog);
